import React, { Component } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { actionCreators } from '../actions/globalAction';
import { StatCard } from '../components/solar/StatCard';
import { ChartCardWithPagination } from '../components/solar/ChartCardWithPagination';
import { getOptions } from '../components/options/yearStromGesamt';
import { data } from '../components/data/yearStromGesamt';
import { yearStromGesamt } from '../components/objects/yearStromGesamt';
import { Bar } from 'react-chartjs-2';
import { Card } from 'react-bootstrap';

class YearStromGesamtClass extends Component {

    static getDerivedStateFromProps(nextProps, prevState) {
        const nextYear = parseInt(nextProps.match.params.Year) || 0;
        if (prevState.prevYear !== nextYear) {
            return { prevYear: nextYear, _fetchNeeded: true };
        }
        return null;
    }

    _fetchData(yearValue, isFirstMount) {
        const Year = parseInt(yearValue) || 0;

        if (Year > 0) {
            yearStromGesamt.YearStromGesamtClass.url = yearStromGesamt.YearStromGesamtClass.defaultSegment + "/gesamtjahr/" + Year;
        }
        else {
            yearStromGesamt.YearStromGesamtClass.url = yearStromGesamt.YearStromGesamtClass.defaultSegment + "/gesamtjahr/" + new Date().getFullYear();
        }

        // Immer forceRefresh setzen, damit Redux den Request nicht als "schon geladen" springt
        yearStromGesamt.YearStromGesamtClass.forceRefresh = true;
        this.props.request(yearStromGesamt["YearStromGesamtClass"]);
    }

    componentDidMount() {
        const initYear = parseInt(this.props.match.params.Year) || 0;
        this.setState({ prevYear: initYear }, () => {
            this._fetchData(this.props.match.params.Year, true);
        });
    }

    componentDidUpdate() {
        if (this.state._fetchNeeded) {
            this.setState({ _fetchNeeded: false }, () => {
                this._fetchData(this.props.match.params.Year, false);
            });
        }
    }

    state = {};

    render() {
        return (
            <div>
                {renderUIKPIRow(this.props)}
                {renderUIGesamt(this.props)}
            </div>
        );
    }
}

function renderUIKPIRow(props) {
    let BarYearStromGesamtUI = props.BarYearStromGesamtUI || {};

    // BOTH isLoaded=true UND Daten vorhanden — nicht nur auf die Flag verlassen!
    let hasData = typeof (BarYearStromGesamtUI.monat) !== 'undefined' && BarYearStromGesamtUI.monat.length > 0;
    let loading = !props.isLoaded || !hasData;

    // KPI-Berechnungen aus API-Daten (nur wenn Daten wirklich da sind)
    let gesamtSumme = 0;
    let eingespeistSumme = 0;
    let verbrauchSumme = 0;
    let bezugSumme = 0;

    if (hasData && typeof (BarYearStromGesamtUI.gesamt) !== 'undefined') {
        for (var i = 0; i < BarYearStromGesamtUI.gesamt.length; i++) {
            gesamtSumme += parseFloat(BarYearStromGesamtUI.gesamt[i]) || 0;
            eingespeistSumme += parseFloat(BarYearStromGesamtUI.eingespeist[i]) || 0;
            verbrauchSumme += parseFloat(BarYearStromGesamtUI.verbrauch[i]) || 0;
            bezugSumme += parseFloat(BarYearStromGesamtUI.bezug[i]) || 0;
        }
    }

    const gesamtKWh = (gesamtSumme / 100).toFixed(0);
    const eingespKWh = (eingespeistSumme / 100).toFixed(0);
    const verbrKWh = (verbrauchSumme / 100).toFixed(0);
    const bezugKWh = (bezugSumme / 100).toFixed(0);

    // Selbstversorgungsquote: Eigenverbrauch / Gesamtproduktion * 100%
    let selvQuote = 0;
    if (gesamtSumme > 0) {
        selvQuote = ((verbrauchSumme / gesamtSumme) * 100).toFixed(1);
    }

    // Konditionale Farbcodierung der Selbstversorgungsquote
    let selvVariant = 'consumption';     // <25% → rot
    if (selvQuote >= 50) { selvVariant = 'energy'; }       // ≥50% → grün
    else if (selvQuote >= 25) { selvVariant = 'progress'; } // ≥25% → blau

    // Jahr aus URL-Parametern oder aktuelles Jahr
    const jahr = parseInt(props.match ? props.match.params.Year : 0) || new Date().getFullYear();

    return (
        <div className="row mb-3">
            <div className="col-12">
                <h5>Jahresuebersicht — Strom {jahr}</h5>
            </div>
            <div className="col-6 col-md-3">
                <StatCard label="Gesamtproduktion" value={gesamtKWh} unit="kWh" rawValue="" isLoading={loading} />
            </div>
            <div className="col-6 col-md-3">
                <StatCard label="Eingespeist" value={eingespKWh} unit="kWh" rawValue="" isLoading={loading} />
            </div>
            <div className="col-6 col-md-3">
                <StatCard label="Eigenverbrauch" value={verbrKWh} unit="kWh" rawValue="" isLoading={loading} />
            </div>
            <div className="col-6 col-md-3">
                <StatCard label="Netzbezug" value={bezugKWh} unit="kWh" rawValue="" isLoading={loading} />
            </div>
            <div className="col-12">
                <StatCard
                    label="Selbstversorgungsquote"
                    value={selvQuote}
                    unit="%"
                    rawValue=""
                    isLoading={loading}
                    variant={selvVariant}
                />
            </div>
        </div>
    );
}

function renderUIGesamt(props) {
    let BarYearStromGesamtUI = props.BarYearStromGesamtUI || {};

    // Loading: BOTH isLoaded=true UND Daten vorhanden. Nicht nur auf die Flag verlassen!
    let hasData = typeof (BarYearStromGesamtUI.monat) !== 'undefined' && BarYearStromGesamtUI.monat.length > 0;
    let loading = !props.isLoaded || !hasData;

    // Stacked-Bar-Chart: Pro Monat EIN Balken, farbig zusammengesetzt aus
    // Eigenverbrauch (Grün) + Eingespeist (Teal) + Netzbezug (Amber)
    let chartData = { labels: [''], datasets: [{ data: [0] }, { data: [0] }, { data: [0] }] }

    // Highlight: Beste und schlechteste Selbstversorgungsquote pro Monat
    let bestMonthName = '-';
    let worstMonthName = '-';
    let bestQuote = 0;
    let worstQuote = 100;

    if (hasData) {
        let labels = [];
        let dataeingespeist = [];
        let dataverbrauch = [];
        let databezug = [];

        for (var i = 0; i < BarYearStromGesamtUI.monat.length; i++) {
            labels.push(BarYearStromGesamtUI.monat[i]);
            dataeingespeist.push(BarYearStromGesamtUI.eingespeist[i]);
            dataverbrauch.push(BarYearStromGesamtUI.verbrauch[i]);
            databezug.push(BarYearStromGesamtUI.bezug[i]);

            // Selbstversorgungsquote pro Monat berechnen (falls verbrauchsProzent da ist)
            if (typeof BarYearStromGesamtUI.verbrauchProzent !== 'undefined') {
                const q = parseFloat(BarYearStromGesamtUI.verbrauchProzent[i]) || 0;
                if (q > bestQuote) {
                    bestQuote = q;
                    bestMonthName = BarYearStromGesamtUI.monat[i];
                }
                if (q < worstQuote) {
                    worstQuote = q;
                    worstMonthName = BarYearStromGesamtUI.monat[i];
                }
            }
        }

        chartData = {
            labels: labels,
            datasets: [
                { ...data.datasets[0], data: dataverbrauch, selfSupplyPercents: BarYearStromGesamtUI.verbrauchProzent || [] },
                { ...data.datasets[1], data: dataeingespeist },
                { ...data.datasets[2], data: databezug }
            ]
        };
    }

    return (
        <div>
            <ChartCardWithPagination
                routeSegment={'yearstromgesamt'}
                onlyYear={true}
                match={props.match}
                history={props.history}
                loading={loading}>
                <Card className="chart-card">
                    <Card.Body>
                        <Bar data={chartData} options={{ ...getOptions(), animation: false }} />
                    </Card.Body>
                </Card>
            </ChartCardWithPagination>

            {/* Highlight-Zeile: Beste und schlechteste Selbstversorgung */}
            {hasData && typeof (BarYearStromGesamtUI.verbrauchProzent) !== 'undefined' && (
                <div className="row mt-2">
                    <div className="col-12">
                        <div className="chart-info-row">
                            <span className="text-success">
                                &bull; Beste Selbstversorgung: {bestMonthName} ({bestQuote.toFixed(1)}%)
                            </span>
                            <span className="text-danger ms-3">
                                &bull; Schlechteste Selbstversorgung: {worstMonthName} ({worstQuote.toFixed(1)}%)
                            </span>
                        </div>
                    </div>
                </div>
            )}
        </div>
    );
}

export default connect(
    state => state.yearStromGesamtReducer,
    dispatch => bindActionCreators(actionCreators, dispatch)
)(YearStromGesamtClass);